import * as actionType from "./orderActionType";

const initialState = {
  isLoading: false,
  order: {},
  orders: [],
  isAdded: false,
  isConfirmed: false,
  confirmedOrder: {},
  coupon: {},
  completedOrder: {}
};

export const orderReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.CREATE_ORDER:
            return {
                ...state,
                isLoading: true,
            };
        case actionType.CREATE_ORDER_FAILURE:
            return {
                ...state,
                isLoading: false,
            };
        case actionType.CREATE_ORDER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                order: action.payload ? action.payload.data : {},
            };
        case actionType.CREATE_ORDER_COD:
            return {
                ...state,
                isLoading: true,
                isConfirmed: false
            };
        case actionType.CREATE_ORDER_COD_FAILURE:
            return {
                ...state,
                isLoading: false,
            };
        case actionType.CREATE_ORDER_COD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                confirmedOrder: action.payload ? action.payload.data : {},
                isConfirmed: true
            };
        case actionType.CONFIRM_ORDER:
            return {
                ...state,
                isLoading: true,
            };
        case actionType.CONFIRM_ORDER_FAILURE:
            return {
                ...state,
                isLoading: false,
            };
        case actionType.CONFIRM_ORDER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isConfirmed: true,
                confirmedOrder: action.payload ? action.payload.data : {}
            };
        case actionType.APPLY_COUPON:
            return {
                ...state,
                isLoading: true,
            };
        case actionType.APPLY_COUPON_FAILURE:
            return {
                ...state,
                isLoading: false,
                coupon: {}
            };
        case actionType.APPLY_COUPON_SUCCESS:
            return {
                ...state,
                isLoading: false,
                coupon: action.payload ? action.payload.data : {}
            };
        case actionType.FETCH_ORDER:
            return {
                ...state,
                isLoading: true,
            };
        case actionType.FETCH_ORDER_FAILURE:
            return {
                ...state,
                isLoading: false,
            };
        case actionType.FETCH_ORDER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                completedOrder: action.payload ? action.payload.data : {}
            };
        case actionType.FETCH_ORDERS:
            return {
                ...state,
                isLoading: true,
            };
        case actionType.FETCH_ORDERS_FAILURE:
            return {
                ...state,
                isLoading: false,
            };
        case actionType.FETCH_ORDERS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                orders: action.payload ? action.payload.data : []
            };
        case actionType.RESET_ORDER_STATE:
            return {
                ...state,
                order: {},
                isConfirmed: false,
                confirmedOrder: {},
                coupon: {}
            };
        default:
            return state;
    }
}